import { memo, useMemo, useState } from 'react';
import { IQsrOrder, OrderPosStatusEnum } from '@/views/QsrOrders/types';
import { useTranslation } from '@/hooks/translations';
import classNames from 'classnames';
import { Tooltip } from '@mui/material';

import styles from './index.module.scss';

// Add tooltipStyles to control spacing
const tooltipStyles = {
    tooltip: {
        marginTop: '5px !important', // Reduced from default to half the space
    },
};

interface IProps {
    order: IQsrOrder;
}

const QsrOrderPosStatus = ({ order }: IProps) => {
    const { t } = useTranslation('common');
    const [open, setOpen] = useState(false);

    const [style, text, visible] = useMemo(() => {
        switch (order.posStatus) {
            default:
            case OrderPosStatusEnum.Pending:
                return [styles.pending, t('pending'), false];
            case OrderPosStatusEnum.Failed:
                return [styles.declined, t('sync failed'), true];
            case OrderPosStatusEnum.Success:
                return [styles.declined, t('success'), false];
        }
    }, [order.posStatus]);

    if (!visible) {
        return null;
    }

    return (
        <div className={classNames(styles.main, style)}>
            {order.posStatus === OrderPosStatusEnum.Failed && order?.posResponseData ? (
                <Tooltip
                    title={order?.posResponseData?.response?.description}
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    componentsProps={{
                        tooltip: {
                            sx: tooltipStyles.tooltip,
                        },
                    }}
                >
                    <div
                        className={styles.status}
                        onClick={() => {
                            setOpen(true);
                        }}
                    >
                        {text}
                    </div>
                </Tooltip>
            ) : (
                <div className={styles.status}>{text}</div>
            )}
        </div>
    );
};

export default memo(QsrOrderPosStatus);
